import ProductPopupDetail from './ProductPopupDetail.jsx';

export {
  ProductPopupDetail
}


// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/index.js